import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/RaamdeoAgarwal.png";
const icon2 = "https://winpeforum.com/assets/elements/VishalTulsiyan.png";
const icon3 = "https://winpeforum.com/assets/elements/nupurgarg.png";

const icon4 = "https://winpeforum.com/assets/elements/AishwaryaNagpal.png";
const icon5 = "https://winpeforum.com/assets/elements/Bala_c_p.png";
const icon6 = "https://winpeforum.com/assets/elements/DivyaMundra.png";
const icon7 = "https://winpeforum.com/assets/elements/KarishmaMakhija.png";
const icon8 = "https://winpeforum.com/assets/elements/LavanyaAshok.png";
const icon9 = "https://winpeforum.com/assets/elements/ManasviniRaj.png";
const icon10 = "https://winpeforum.com/assets/elements/NanikaKakkar.png";

const icon11 = "https://winpeforum.com/assets/elements/NidhiGhuman.png";
const icon12 = "https://winpeforum.com/assets/elements/NidhiSaraf.png";
const icon13 = "https://winpeforum.com/assets/elements/PriyadarshiniRao.png";
const icon14 = "https://winpeforum.com/assets/elements/RituVerma.png";
const icon15 = "https://winpeforum.com/assets/elements/RochelleDSouza.png";
const icon16 = "https://winpeforum.com/assets/elements/SwatiBhartia.png";
const icon17 = "https://winpeforum.com/assets/elements/TanushreeAgarwal.png";

let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/17oct2024/1.jpg";
const I2 = "https://www.winpeforum.com/assets/sheshines/17oct2024/2.jpg";
const I3 = "https://www.winpeforum.com/assets/sheshines/17oct2024/3.jpg";
const I4 = "https://www.winpeforum.com/assets/sheshines/17oct2024/4.jpg";
const I5 = "https://www.winpeforum.com/assets/sheshines/17oct2024/5.jpg";
const I6 = "https://www.winpeforum.com/assets/sheshines/17oct2024/6.jpg";
const I7 = "https://www.winpeforum.com/assets/sheshines/17oct2024/7.jpg";
const I8 = "https://www.winpeforum.com/assets/sheshines/17oct2024/8.jpg";
const I9 = "https://www.winpeforum.com/assets/sheshines/17oct2024/9.jpg";
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/1.jpg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/2.jpg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/3.jpg";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/4.jpg";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/5.jpg";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/6.jpg";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/7.jpg";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/8.jpg";
const II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/9.jpg";
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker1 = [
        {
          imgUrl: icon1,
          desc: `Raamdeo Agrawal is the co-founder of Motilal Oswal Financial Services Limited (MOFSL) and one of India's most celebrated investors with more than three decades of investing experience. Under his leadership, MOFSL has emerged as a multi-location, multi-business financial services conglomerate. <br/><br/>
  
  He pioneered the equity research practice at MOFSL, the first by any Indian brokerage house, in the early 90s. Mr. Agrawal's 'value investing' philosophy enables him to pick high-potential small and midcap companies early that eventually become large caps. He drives the annual 'Wealth Creation Study' that has become a benchmark document analysing the top 100 wealth creating companies and decoding their success stories. Mr. Agrawal has also been instrumental in creating the Quality, Growth, Longevity and Price (QGLP) framework that forms the core investing philosophy of MOFSL and Motilal Oswal Private Equity.
  <br/><br/>
  Raamdeo is an Associate of The Institute of Chartered Accountants of India (ICAl and a member of the National Committee on Capital Markets of the Confederation of Indian Industry (CII). He has also featured on the 'Wizards of Dalal Street' on CNBC-TV18. In 1986, he co-authored, 'Corporate Numbers Game', with Mr. Ram K Piparia. He also authored 'The Art of Wealth Creation'.
  
  
           `,
          name: "Raamdeo Agarwal",
          post: `<div>Chairman & Co-founder,<br/>Motilal Oswal Financial Services Ltd
  
          </div>`,
        }
    ];
    this.Speaker3 = [
        {
            imgUrl: icon2,
            desc: `Vishal Tulsyan founded Motilal Oswal Private Equity in 2006 with MOFSL as its sponsor. He is directly involved in identifying businesses and supporting portfolio companies, and has built a platform to channelise long-term capital to create valuable enterprises and successful entrepreneurs. 
    <br/><br/>
    Vishal spent over two decades in the Indian financial sector across private equity, investment banking and structured finance before co-founding Motilal Oswal Private Equity. He brings on board his deep experience of raising, investing and returning third-party capital across several economic cycles. He worked with Rabobank, helping build its corporate finance and investment banking franchise. He was also responsible for the origination and execution of structured finance, project finance, acquisition finance, private equity and M&A transactions. 
    <br/><br/>
    He holds a Bachelor's degree in Commerce from the St. Xavier's College, Kolkata and is a member of The Institute of Chartered Accountants of India.
    
    
            
             `,
            name: "Vishal Tulsiyan",
            post: `<div>MD and CEO, <br/>MO Alternate Investment Advisors
    
            </div>`,
          } 
    ];
    this.Speaker4 = [
        {
            imgUrl: icon3,
            desc: `Nupur Garg is a leading investor in private equity and venture capital
and an expert advisor to large institutional investors. She is the
founder of Winpe, an initiative to enhance gender diversity in the
investing ecosystem.<br/><br/>
Nupur serves as Chairperson of the board of Kids Clinic India
Limited (Cloudnine chain of hospitals) and an independent director
on the boards of Edelweiss Real Assets Managers Limited and
Molbio Diagnostics Limited. She is an advisor to and a member of
the investment committee for the Dutch Good Growth Fund
(DGGF) investment funds mandate given by the Dutch government
for investments in SMEs in frontier markets across 75 countries.<br/><br/>
Nupur has served two terms on the board of SIDBI, the Indian DFI,
as an early member of the investment committee at the Fund of Funds managed by the National
Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government
of India and on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for
investing in the Indian start-up ecosystem; guiding the development of their investment programs. Nupur
advises select fund managers on a confidential basis on matters related to institutionalization, best practices
and governance. She also mentors female entrepreneurs across various platforms.<br/><br/>
Nupur is recognized as a thought and industry leader with a list of recognitions that include the Private
Equity International Most Influential Women (global) 2024, BW VC World Most Influential Women 2024,
2023 and 2022, HerPower Award 2023, Forbes W-Power list of Self Made Women 2020, India’s top 10
Women Leaders in Finance (AIWMI 2019), Vedica Women’s Alliance’s Women Leader in D&I 2022,
Women Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best
Practices - Academia Award 2019.<br/><br/>
In her previous role, Nupur led the private equity and venture capital funds business in the region for IFC
and is widely credited with establishing IFC’s brand and credibility as one of the most respected
institutional investors in this space. Under her stewardship, the portfolio doubled in size and returns,
moving from a negative IRR to delivering gains for the first time in its history.<br/><br/>
Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from
Harvard Business School.<br/><br/>
Nupur loves to spend time with her mother, husband and 10-year-old son, travel to new places, read and
do 1500-piece puzzles.
    
             `,
            name: "Nupur Garg",
            post: `<div>Founder,<br/>Winpe
            </div>`,
          } 
    ];
    this.Speaker2 = [
      
     
     
      {
        imgUrl: icon4,
        desc: `<div>
      Aishwarya Nagpal is a Partner in the Corporate and Commercial practice group in the Mumbai office. She specialises in corporate and commercial transactions, including acquisitions, joint ventures, cross-border transactions, private equity investments, and routine advisory on all aspects of Indian corporate and foreign investment laws.
<br/><br/>
Aishwarya advises private equity funds and other financial sponsors and their portfolio companies on a wide range of transactions, across a variety of sectors, including healthcare, IT & ITES, manufacturing, EdTech, logistics, real estate and financial services.

        </div>`,
        name: "Aishwarya Nagpal",
        post: `<div>Partner,<br/>Khaitan & Co

        </div>`,
      },
      {
        imgUrl: icon5,
        desc: ` Bala C Deshpande is the Founder and Partner of MegaDelta Capital. Of her 30 years of experience Bala has two decades of investing experience. She started her investing career with ICICI Venture in 2001 and in 2008 she joined NEA to set up their India platform. Over the years, she has invested and backed many disruptive companies in the mid-market space. In October 2018, she along with two Partners founded an independent investment firm, MegaDelta Capital. Prior to her investing experience, Bala has had deep operating experience with reputed multi-national firms such as ICI, Cadbury’s and BestFoods.
<br/><br/>
Bala's investment career spans multiple sectors and she has played an instrumental role in many innovative plays and entrepreneurial journeys. These include the first Internet IPO, first 24-hour news channel, first Payment Tech company, several consumer companies that redefined the sector etc.
<br/><br/>
She is a Board member of deeply disruptive companies like Info Edge Ltd., FSS, Greytip HR, MediSys Edutech, Panacea Medical Technologies, GOQii Inc etc. With her Board participation these companies have grown exponentially, emerged as category leaders and created immense shareholder value.
<br/><br/>
She is passionate about Technology and its far-reaching implications on markets, businesses and consumers. She is keen to back entrepreneurs who redefine markets and create lasting economic value.


         `,
        name: "Bala C Deshpande",
        post: `<div>Founder & Partner,<br/>
MegaDelta Capital

        </div>`,
      },
      {
        imgUrl: icon6,
        desc: `Divya Mundra has 15 years of experience and specializes in Mergers & Acquisitions, Joint Ventures, General Corporate and Private Equity. Divya represents a range of domestic and international clients across various sectors, including agriculture, banking, fashion, healthcare, luxury goods, media, retail and technology.
         `,
        name: "Divya Mundra",
        post: `<div>Senior Partner,<br/>AZB & Partners
 
        </div>`,
      },
      {
        imgUrl: icon7,
        desc: `<div>
      Karishma joined MOPE in 2021. She is responsible for transaction evaluation, financial analysis, deal documentation and portfolio management.
<br/><br/>
Prior to joining Motilal Oswal Private Equity, Ms. Makhija had over 11 years of experience in Investment Banking (Spark Capital, IIFL, HDFC Bank & KPMG) across Private equity, M&A & Capital Market fund raises. During her career, she has successfully executed transactions, some of the notable ones include private equity transactions in TransUnion CIBIL, India Shelter Finance and EssKay Finance, acquisition of Micro Housing Finance by Svatantra Microfinance & IPO of AU Financiers.
<br/><br/>
Ms. Makhija holds a Bachelor's Degree in Commerce from NM College of Commerce and Economics, Mumbai and is a member of the Institute of Chartered Accountants of India.


  
        
        </div>`,
        name: "Karishma Makhija",
        post: `<div>Senior Vice President,<br/>Motilal Oswal Alternates

         
        </div>`,
      },
      {
        imgUrl: icon8,
        desc: `<div>
    Lavanya brings deep life cycle growth equity investing experience to the firm. She has deployed funds, mentored portfolio companies through their journey and created healthy exit outcomes for investors in both India and the US. She joined Trifecta Capital to build out its late-stage equity platform, to consolidate its position as the financing partner for the new economy. She also cultivates a deep interest in fitness, yoga and mindfulness.<br/>
<ul><li>15 years of growth equity investing and investment banking experience.</li>
<li>Previously, M.D., Goldman Sachs Principal Investing, a senior member of a 12-person team deploying funds from GS’ balance sheet and USD 8 Bn global private equity fund in India.</li>
<li>Lifecycle investing experience including investments in Pepperfry, Azure, Cytecare and successful exits in Mahindra & Mahindra, Max India, and TVS Logistics.</li>
<li>Also worked at SPO Partners, a value-investing oriented hedge fund in California managing USD 10 Bn, and Goldman Sachs investment banking in New York.</li></ul>
 
        </div>`,
        name: "Lavanya Ashok",
        post: `<div>Partner,<br/>Trifecta Capital
 
        </div>`,
      },
      {
        imgUrl: icon9,
        desc: `<div>
      Manasvini has over 13 years of experience in advising private equity funds, large corporate conglomerates, lenders, multilateral institutions, export credit agencies, sponsors, investors, borrowers and contractors. With a specialization in project finance, structured finance, project development and M&A in the infrastructure and energy sectors, she has led high-value deals and cross-border transactions across Asia, Middle East, Australia and North America.
<br/><br/>
Manasvini has worked at White & Case LLP. (New York office) for almost 2 years and also at International Finance Corporation (the World Bank Group) as part of their Asia Legal Team for 2 years.

        
        </div>`,
        name: "Manasvini Raj",
        post: `<div>Partner,<br/>Cyril Amarchand Mangaldas
        
        </div>`,
      },
      {
        imgUrl: icon10,
        desc: `<div>
   
Nanika Kakkar serves as Partner at Cornerstone Venture Partners(India). She serves as Board Member at Karomi. She brings in 10+ years of investing experience across asset classes and stages. In her last role, she was managing International venture investing and portfolio management for Reliance Industries Limited, managing their funds in Israel and India, and investing in early and growth-stage emerging technologies.

        </div>`,
        name: "Nanika Kakkar",
        post: `<div> Partner,<br/>Cornerstone Venture Partners Fund
 
        </div>`,
      },
      {
        imgUrl: icon11,
        desc: `<div>
    Nidhi Ghuman is the Founder of Vinceré Partners. Prior to this, she was Fund Manager with 360 ONE Asset AMC’s private equity team. In this role, she leads investments for IIFL’s growth equity & pre-IPO private equity funds. She has also worked as a Principal at Multiples Private Equity where she invested across growth, buyout and turnaround situations in businesses in healthcare, pharma and business services sectors. She started her career with SBI Capital Markets and GE Capital where she advised companies on equity and debt fund raising, M&A, and debt restructuring. She holds a MBA from XLRI Jamshedpur and B.Tech from IIT Madras.

  
        
        </div>`,
        name: "Nidhi Ghuman",
        post: `<div>Founder,<br/>Vinceré Partners


         
        </div>`,
      },
      {
        imgUrl: icon12,
        desc: `<div>
     Nidhi’s career spans the startup ecosystem way back in 2009, a startup evangelist, she has been the first employee of Mumbai Angels and started her journey when startup ecosystem was new to India.
<br/><Br/>
Worked with leading angel networks in the country like Indian Angel Network(IAN), Intellecap Impact Investment Network (I3N) and Mumbai Angels while working with Portfolio companies of Mumbai Angels–Wild East Group. Working with KKR, Yash Raj Films, Dr. Seuss amongst the few was an experience which can’t be defined. An angel investor in few start-ups ay her individual capacity while mentoring a few. After the stint with the angel groups, the entrepreneurial bug bit her to start a new journey for herself, as an entrepreneur. Being a part of this dynamic ecosystem that is meant to happen. Key Venture, raises funds for Seed, Angel and Series A, B investments for both Equity and Debt, largely focused in India. It has individual and institutional investors spread globally.  Key Venture works very closely with large corporations to leverage their ability in the start-up ecosystem.


        </div>`,
        name: "Nidhi Saraf",
        post: `<div>Founder & CEO,<br/>Key Venture

        </div>`,
      },
      {
        imgUrl: icon13,
        desc: `<div>
    I am an India qualified Capital Markets lawyer, based out of Mumbai. I have been recognized by the Legal500, IFLR1000 (Rising Star Partner - Capital Markets) and AsiaLaw (Rising Star - Capital Markets), and shortlisted as a Lawyer of the Year (Equity Capital Markets) by Women in Business Law Awards 2023 APAC.
<br/><br/>
I have advised a wide range of clients across sectors such as NATCs, manufacturing, retail/wholesale, QSR, BFSI (banks, MFI, insurance), energy etc., on initial public offerings, qualified institutions placements, rights issues, offers for sale and foreign debt issuances, from the perspective of Indian law. On these transactions, I have advised the issuers, merchant bankers and more recently private equity funds as selling shareholders.
<br/><br/>
Other than transactional practice, I have also helped my listed clients and merchant banking clients periodically with their ongoing securities law obligations.
<br/><br/>
In my free time I enjoy travelling, being outdoors and meeting new people.

  
        
        </div>`,
        name: "Priyadarshini Rao",
        post: `<div>Partner,<br/>Induslaw


         
        </div>`,
      },
      {
        imgUrl: icon14,
        desc: `<div>
    Ritu Verma is the co-founder and Managing Partner at Ankur Capital – an early stage venture capital firm that invests in disruptive digital and science led technologies. She is passionate about supporting breakthrough ideas that can solve challenging problems and create a better world. She has sat on the sides of many category creating companies as they establish roots and scale across the globe over the past 10 years. Ritu sits on the board/board observer positions at multiple of Ankur’s portfolio – Cropin, Niramai, StringBio, Vegrow, Krishify, Piatrika, OffGrid, IBISA, Superfone and BigHaat. 
<Br/><Br/>
Prior to starting Ankur Capital, Ritu ran Truven an advisory firm for venture funds looking at investments in India and SE Asia. One of the funds she worked with was BASF corporate venture fund, which focused on investments in renewable energy, agri-biotech and materials. She has also brought products from lab to market across the globe as parts of innovation teams in Unilever and Philips working across roles from product development to marketing strategy. She holds 7 patents and has authored and contributed to seven peer reviewed research publications in prestigious journals. Ritu is a director and a member of the steering committee at ThinkAg a non-profit platform for scaling ag-tech innovations in India. She is a member of the Global Development Committee for American Society of Mechanical Engineers that focuses on hardware innovations globally. She is also a member of the Core Advisory Committee for the Centre of Excellence in Agri Innovation at C-CAMP and IKP Advisory Group for our Agri and Sustainability. She has also been part of government led initiatives to drive agricultural growth and sustainability. She holds an MBA from INSEAD and a Ph.D. in physics from the University of Pennsylvania and has bachelors from Middlebury College, Vermont.

        
        </div>`,
        name: "Ritu Verma",
        post: `<div>Managing Partner,<Br/>
Ankur Capital


         
        </div>`,
      },
      {
        imgUrl: icon15,
        desc: `<div>
   Rochelle D’Souza is a managing director at Lighthouse Advisors, a leading mid-market, private equity investment firm. She co-leads the investment team and specializes in food, healthcare and agri sectors. Ms. D’Souza’s current board positions include Tynor Orthotics, the largest orthotics soft good company in India, Wow! Momo Foods, which is India’s largest homegrown QSR brand, and V2 Retail, a leading value retailer. In her personal time, she serves as a mentor for the YEA Academy and is also an ambassador for WinPE, the network for women in private equity. She was Ranked among the Top 100 Women inFinance by AIWMI in 2019; Ms. D’Souza received her MBA from the SP Jain School of Management and holds a Bachelor in Engineering in Electronics from RVCE.
 
        </div>`,
        name: "Rochelle D’Souza",
        post: `<div>MD,<br/>Lighthouse
    
        </div>`,
      },
      {
        imgUrl: icon16,
        desc: `<div>
     Swati Bhartia is a Principal at Motilal Oswal Private Equity. She has more than 15 years of experience in managing PE investments and equity research. Before joining MOPE, she worked with Tata Capital Healthcare Fund (TCHF) for nine years. During her stint with TCHF, Swati was involved in end to end deal management and successfully deployed USD 100+ Mn. Prior to that, she worked with Oman India Joint Investment Fund (OlJIF), where she was involved in deal evaluation across diverse sectors such as healthcare, machine tools, auto ancillaries, specialty chemicals and pharmaceuticals. She started her career with Crisil as equity Research Analyst in 2005, covering European mid & large-cap Biotech companies.
<br/><Br/>
Swati is a 37th All India rank-holder Chartered Accountant and a CFA charter-holder. She is a part of Bloomberg's Women Buy-side Network (India) and featured as Top 40 Alternate Investment Professionals in India by AlWMI.
 
        </div>`,
        name: "Swati Bhartia",
        post: `<div>Director,<br/>Motilal Oswal Private Equity

        </div>`,
      },
      {
        imgUrl: icon17,
        desc: `<div>
  Tanushree is an investment professional with 14 years of experience in private equity and project finance over diverse sectors such as real estate, infrastructure, and allied sectors. At Sabre, she is responsible for deal sourcing, evaluation of potential investment opportunities and managing investments in financial services, healthcare, and climate change sectors.
<br/><Br/>
Prior to Sabre, Tanushree has spent the past 8 years working with the commercial and residential funds of Edelweiss Alternate Asset Advisors and Milestone Capital Advisors. Apart from managing the entire deal life cycle, she was also involved in fund-raising by way of conceptualizing the fund strategy and formulating the marketing and fund documents She has managed over INR 7.5 billion assets across six different funds being involved in end-to-end fund lifecycle. Prior to this she was a part of the Infrastructure Banking/Project Finance team at Yes Bank for 4 years.
<br/><Br/>
Tanushree holds an MBA in finance from Faculty of Management Studies, Delhi, and has also cleared all three levels of CFA (USA). She is a B.E. in Computer Engineering from Sardar Patel College of Engineering (Mumbai University).

  
        
        </div>`,
        name: "Tanushree Agarwal",
        post: `<div>Partner,<br/>Sabre Partners
        </div>`,
      } 
      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      { id:27, ImgSrc: I2, ImgSrc1: II2,},  
        
      

        { id:62, ImgSrc: I3, ImgSrc1: II3,},    
        { id:28, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   

        { id:22, ImgSrc: I6, ImgSrc1: II6,},   
        { id:19, ImgSrc: I7, ImgSrc1: II7,},  
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   
        { id:34, ImgSrc: I9, ImgSrc1: II9,},  
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">sheshines with Winpe </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>October 17, 2024 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>Motilal Oswal Tower, Prabhadevi, Mumbai </i></span>
                </div>
              </div>
              <center><h4>Hosted by: Motilal Oswal
              </h4>  
           
          </center> <br/>  <br/> 
              {/* <div className="College_page">
                <span>
                  <img
                    src="https://px.ads.linkedin.com/collect/?pid=2117884&conversionId=2310748&fmt=gif"
                    alt="events link"
                  />
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfTEePX88AjH_IGhVYAQtB5B3oqLlK4qQe8lsA-qnijKuiydQ/viewform"
                    target="_blank"
                  >
                    Register Now
                  </a>
                </span>
              </div> */}
              <div className="top_text">
              The Winpe sheshines event, hosted by Motilal Oswal in Mumbai on October 17, 2024, was a resounding success. The evening’s theme was <b>"How Investors Add Value to Investee Companies,"</b> which brought together a distinguished group of investment professionals for an insightful and engaging discussion. <br/><br/>
The highlight of the event was the fireside chat with Raamdeo Agarwal, Chairman & Co-founder of Motilal Oswal Financial Services Ltd. and Vishal Tulsiyan, MD & CEO of MO Alternates who shared strategic insights on how long term investors can harness the power of compounding and a compelling discussion underscoring the business advantages of gender diverse teams. The conversation was moderated by Nupur Garg, founder of Winpe.  <br/><br/>

The roundtable discussions focused on sustaining long-term growth, emphasising on value creation for shareholders and stakeholders via strategic guidance, operational expertise, and networks to help companies scale, while enhancing governance and offering capital for expansion. The exciting format catalyzed cross learnings across strategies and stages and the atmosphere was charged with intellectual energy, as participants engaged in vibrant discussions and posed thought-provoking questions. So much so that Winpe announced that it would offer the WLSA giveaways for all questions asked rather than to the best 4.  <br/><br/>
The evening concluded with lots of networking over snacks and beverages, leaving attendees looking forward to future Winpe events. With discussions like these, Winpe sheshines is steadily advancing the visibility and influence of women in investing.




              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
     <center>  
         <a href="gallery/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button">View All Images</button> </a> </center> 
       
          
 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
              <div className="top_text">
<p>The esteemed lineup of speakers included Aishwarya Nagpal, Partner at Khaitan & Co, Divya Mundra, Senior Partner at AZB & Partners, Karishma Makhija, Senior Vice President at MOPE Investment Advisors Pvt. Ltd., Lavanya Ashok, Partner at Trifecta Capital, Manasvini Raj, Partner at Cyril Amarchand Mangaldas, Nanika Kakkar, Partner at Cornerstone Venture Partners Fund, Nidhi Ghuman, Founder of Vincere, Nidhi Saraf, Founder & CEO of Key Venture, Priyadarshini Rao, Partner at Induslaw, Ritu Verma, Managing Partner at Ankur Capital, Rochelle Dsouza, MD at Lighthouse, and Tanushree Agarwal, Partner at Sabre Partners. </p>
</div>
              <div className="row"  style={{ width: '60%', marginLeft:'20%'  }}> 
                  <div className="col-md-4">
                     
                             
              <div className="Our_Speakers container"><h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "25px", textAlign:'center' }}>Special Invitee</h2> 
                        <center>
                          <div className="Speakers_img" style={{ width: '100%' }}>
                            <div className="row">

                              {this.Speaker1.map((item, i) => {
                               
                                return (
                                  <div
                                    className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
                                    key={i}
                                  >
                                    <div className="Scardd">
                                      <div
                                        className="s_img"
                                        onClick={() => this.togglePopUp(item)}
                                      >
                                         <center>  <img
                                          src={item.imgUrl}
                                          alt={item.name}
                                          className="img-responsive"
                                          style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                        />
                                        </center>
                                      </div>
                                      <br />    <div
                                        className="Speakers_name"
                                        dangerouslySetInnerHTML={{ __html: item.name }}
                                      ></div>
                                      <div
                                        className="Speakers_post"
                                        dangerouslySetInnerHTML={{ __html: item.post }}
                                      ></div>
                                    </div>
                                  </div>
                                );
                              
                               
                              })}
                            </div>
                          </div>

                        </center>
                      </div>


                    
                    </div>    
                    <div className="col-md-4">
                    
                    
                    <div className="Our_Speakers container">
                    <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "25px", textAlign:'center' }}>In the Hot Seat</h2>   <center>
                                <div className="Speakers_img" style={{ width: '100%' }}>
                                  <div className="row">
      
                                    {this.Speaker3.map((item, i) => {
                                     
                                      return (
                                        <div
                                          className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
                                          key={i}
                                        >
                                          <div className="Scardd">
                                            <div
                                              className="s_img"
                                              onClick={() => this.togglePopUp(item)}
                                            >
                                               <center>  <img
                                                src={item.imgUrl}
                                                alt={item.name}
                                                className="img-responsive"
                                                style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                              />
                                              </center>
                                            </div>
                                            <br />    <div
                                              className="Speakers_name"
                                              dangerouslySetInnerHTML={{ __html: item.name }}
                                            ></div>
                                            <div
                                              className="Speakers_post"
                                              dangerouslySetInnerHTML={{ __html: item.post }}
                                            ></div>
                                          </div>
                                        </div>
                                      );
                                    
                                     
                                    })}
                                  </div>
                                </div>
      
                              </center>
                            </div>
      
      
                          
                          </div>    
                          <div className="col-md-4">
                     
                    <div className="Our_Speakers container">
                    <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "25px", textAlign:'center' }}>Moderator</h2>      <center>
                                <div className="Speakers_img" style={{ width: '100%' }}>
                                  <div className="row">
      
                                    {this.Speaker4.map((item, i) => {
                                     
                                      return (
                                        <div
                                          className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
                                          key={i}
                                        >
                                          <div className="Scardd">
                                            <div
                                              className="s_img"
                                              onClick={() => this.togglePopUp(item)}
                                            >
                                               <center>  <img
                                                src={item.imgUrl}
                                                alt={item.name}
                                                className="img-responsive"
                                                style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                              />
                                              </center>
                                            </div>
                                            <br />    <div
                                              className="Speakers_name"
                                              dangerouslySetInnerHTML={{ __html: item.name }}
                                            ></div>
                                            <div
                                              className="Speakers_post"
                                              dangerouslySetInnerHTML={{ __html: item.post }}
                                            ></div>
                                          </div>
                                        </div>
                                      );
                                    
                                     
                                    })}
                                  </div>
                                </div>
      
                              </center>
                            </div>
      
      
                          
                          </div>    
                       </div>      
                  <div className="row"> 
                   
              <div className="Our_Speakers container">
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "25px", textAlign:'center' }}>Industry Roundtable
              </h2>           <center>
                          <div className="Speakers_img" style={{ width: '75%' }}>
                            <div className="row">

                              {this.Speaker2.map((item, i) => {
                               
                                return (
                                  <div
                                    className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                    key={i}
                                  >
                                    <div className="Scardd">
                                      <div
                                        className="s_img"
                                        onClick={() => this.togglePopUp(item)}
                                      >
                                         <center>  <img
                                          src={item.imgUrl}
                                          alt={item.name}
                                          className="img-responsive"
                                          style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                        />
                                        </center>
                                      </div>
                                      <br />    <div
                                        className="Speakers_name"
                                        dangerouslySetInnerHTML={{ __html: item.name }}
                                      ></div>
                                      <div
                                        className="Speakers_post"
                                        dangerouslySetInnerHTML={{ __html: item.post }}
                                      ></div>
                                    </div>
                                  </div>
                                );
                              
                               
                              })}
                            </div>
                          </div>

                        </center>
                      </div>

                      </div>  

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/SheShines17Oct2024/index.js